import React from 'react'
//import Extra from '../models/Extra.js';

export default class RentalList extends React.Component {
  constructor(props){
    super(props);

    //console.log('Extras Llist')
    //console.log(this.props)
    this.state = {
      extrasSelected : [],
      addlDrivers : 0
    };

    // call bind to use this in function
    this.handleExtraSelect = this.handleExtraSelect.bind(this);
    this.handleAddlDriverSelect = this.handleAddlDriverSelect.bind(this);
  }

  componentDidMount() {
    //console.log(this.props.extrasSelected)

    var extrasSelected = [];
    if(this.props.extrasSelected && this.props.extrasSelected.length > 0)
      extrasSelected = this.props.extrasSelected;
      this.setState({ extrasSelected : this.props.extrasSelected}, () => {
        //this.props.getBill(this.state.extrasSelected);

        // preset addl drivers to update addl driver select
        var addlDriverCount = this.addlDriverCount();
        if(addlDriverCount > 1){
          this.setState({addlDrivers : addlDriverCount });
        }
      });

    this.props.getBill(extrasSelected);
  }

  handleExtraSelect(e){
    //e.preventDefault();
    //console.log('EXTRA input checked')

    var code = e.target.value;
    var extras = this.state.extrasSelected;

    //console.log(this.state.extrasSelected)
    if(e.target.checked){
      extras.push(code);
    }else{ // remove it
      extras = extras.filter((ex, index) => {
        return ex !== code;
      });

      // reset addl drivers
      var addlDrivers = this.state.addlDrivers
      if(code === '002')
        addlDrivers = 1;

      /*const index = extras.indexOf(code);
      if (index > -1)
        extras.splice(index, 1);*/
    }
     this.setState({
        extrasSelected : extras,
        addlDrivers : addlDrivers
    }, () => {
      // call to recalculate bill with added extra
      this.props.getBill(this.state.extrasSelected);
    });
  }

  handleAddlDriverSelect(e){
    var addlDrivers = e.target.value;
    var extras = this.state.extrasSelected;
    var code = '002';

    var addlDriverCount = this.addlDriverCount();

    var needToAdd = addlDrivers - addlDriverCount;
    //console.log(needToAdd)
    // add
    while(needToAdd > 0){
      extras.push(code);
      needToAdd--;
    }
    // remove
    while(needToAdd < 0){
      const index = extras.indexOf(code);
      //console.log(index)
      if (index > -1)
        extras.splice(index, 1);
      needToAdd++;
    }

    this.setState({
        extrasSelected : extras,
        addlDrivers : addlDrivers
    }, () => {
      // call to recalculate bill with added extra
      this.props.getBill(this.state.extrasSelected);
    });
  }

  addlDriverCount(){
    var extras = this.state.extrasSelected;
    var addlDriverCount = 0;
    var code = '002';

    for(var i = 0; i < extras.length; i++){
      if(extras[i] === code)
        addlDriverCount++;
    }
    return addlDriverCount;
  }

  isExtraSelected(code){
    const extrasSelected = this.state.extrasSelected;
    var isSelected = false;
    for(var i = 0; i < extrasSelected.length; i++){
      if(extrasSelected[i] ===  code)
        isSelected = true;
    }
    return isSelected;
  }

  render() {
    //console.log('Extras List render called');
    //console.log(this.props.rental_list)

    const extrasList = this.props.extrasList;
    //const extrasSelected = this.state.extrasSelected;

    var Extras =
    extrasList.map(
      (extra, index) =>
        <div className="list-item" key={extra.extraCode + '-' + index}>
          <input type="checkbox" name="extra" value={extra.extraCode} onChange={this.handleExtraSelect} checked={this.isExtraSelected(extra.extraCode)
            /*extrasSelected.find((ex) => {
              if(ex.extraCode)
                return ex === extra.extraCode
              else
                return ""
            })*/ } />
          {extra.extraDesc === 'ADDITIONAL DRIVER' ?
          <select name="addlDrivers" value={this.state.addlDrivers} onChange={this.handleAddlDriverSelect}>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
          </select> : ''}
          {extra.extraDesc} - ${extra.extraAmount}
        </div>
    );

    return (
      <div>
        <h3>Choose Extras</h3>
        {Extras}
      </div>
    )
  }
}
